<template>
  <b-modal
    id="modal-rfid"
    ref="modalRFID"
    size="xl"
    centered
    title="Kelola RFID"
    data-me="master-fr-modal-manage-rfid"
  >
    <b-card class="mc-card mc-card__setting mc-card__setting--rfid">
      <b-tabs content-class="p-3 text-muted">
        <!-- Tag Tab -->
        <RFIDTagTab data-me="master-fr-modal-tab-tag" />

        <!-- Reader Tab-->
        <RFIDReaderTab data-me="master-fr-modal-tab-reader" />
      </b-tabs>
    </b-card>
    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn mt-0">
          <McButton
            data-me="master-fr-modal-btn-close"
            variant="outline-primary"
            class="me-2"
            :text="$t('global.action.close')"
            @click="cancel()"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import appConfig from '@/app.config'
import McButton from '@/components/McButton'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import RFIDTagTab from '@/router/views/master/rfid-facerecognition/components/TagTab'
import RFIDReaderTab from '@/router/views/master/rfid-facerecognition/components/ReaderTab'

export default {
  name: 'ModalRFID',
  components: {
    McButton,
    RFIDTagTab,
    RFIDReaderTab,
  },
  mixins: [Helper],
  data() {
    return {
      selectedTab: 'tag',
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
  },
  methods: {
    show() {
      this.$refs.modalRFID.show()
    },
    hide() {
      this.$refs.modalRFID.hide()
    },
    save() {
      // Implement save logic here
      this.hide()
    },
  },
}
</script>
<style lang="scss">
.mc-tab__rfid .mc-table .p-4 {
  padding: 0 !important;
}
</style>
